import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { font } from "../constants/font";

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px 8px 0px 0px;
  gap: 12px;
  align-items: center;
  z-index: 2;
  ${(props) =>
    props.isChecked &&
    css`
      display: flex !important;
    `}
  ${(props) => props.styles}
  ${(props) =>
    props.isActiveCheckBox &&
    css`
      display: flex !important;
      flex-direction: row-reverse;
      justify-content: space-between;
    `}
    ${(props) => props.isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
      // pointer-events: none;
    `}
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 4px;
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  border: 1px solid ${(props) => props.checkBoxColor};
  width: ${(props) => props.checkBoxWidth};
  height: ${(props) => props.checkBoxHeight};
  background: ${(props) =>
    props.isChecked
      ? props.checkBoxActiveColor || props.theme.checkBoxTickColor
      : props.theme.polarColor};
  transition: all 150ms;
  ${Icon} {
    visibility: ${(props) => (props.isChecked ? "visible" : "hidden")};
  }
  border-radius: ${(props) => props.borderRadius};
  ${(props) =>
    props.isChecked &&
    css`
      border-color: ${(props) =>
        props.checkBoxActiveColor || props.theme.checkBoxTickColor};
    `}
`;

const CheckBox = (props) => {
  const { onHandlerClick, id, label, selectedValue, isActiveCheckBox = false, isChecked: controlledChecked, isDisabled, ...restProps } = props;

  const [isChecked, setIsChecked] = useState(Boolean(controlledChecked));

  const toggle = (checked) => {
    setIsChecked(checked);
    onHandlerClick(checked, selectedValue);
  };

  // 🔹 wrapper click
  const onWrapperClick = () => {
    toggle(!isChecked);
  };

  // 🔹 input change (keyboard / label)
  const onInputChange = (e) => {
    if (isDisabled) return;
    toggle(e.target.checked);
  };

  useEffect(() => {
    setIsChecked(Boolean(controlledChecked));
  }, [controlledChecked]);

  const handleClick = () => {
    if (isDisabled) return;
    onWrapperClick();
  };

  return (
    <CheckboxContainer isDisabled={isDisabled} onClick={handleClick} isActiveCheckBox={isActiveCheckBox} isChecked={isChecked} {...restProps}>
      <HiddenCheckbox id={id} checked={isChecked} onChange={onInputChange} disabled={isDisabled} />
      <StyledCheckbox {...props} isChecked={isChecked}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
      <label htmlFor={id} onClick={(e) => e.stopPropagation()}
        style={{
          font: font.normalBase_21,
          cursor: isDisabled ? "not-allowed" : "pointer"
        }}
      >{label}</label>
    </CheckboxContainer>
  );
};
/**
 * Default Props Value for Toggle
 */
CheckBox.defaultProps = {
  onHandlerClick: () => { },
  isChecked: false,
  checkBoxWidth: "16px",
  checkBoxHeight: "16px",
  borderRadius: "0px",
};

/**
 * Initialize Prop Types for Toggle
 */
CheckBox.propTypes = {
  id: PropTypes.string,
  onHandlerClick: PropTypes.func,
  isChecked: PropTypes.bool,
  checkBoxWidth: PropTypes.string,
  checkBoxHeight: PropTypes.string,
  isActiveCheckBox: PropTypes.bool,
  borderRadius: PropTypes.string,
  label: PropTypes.string,
  selectedValue: PropTypes.string,
  isDisabled: PropTypes.bool,
  'data-tooltip-id': PropTypes.string,
};

export default CheckBox;
